import _ from 'lodash';
import {APP_CONFIG} from "./config";
import axios from 'axios';
import store from './store/store';
import {router} from "./router";
import {Utils} from "./helpers/utils";
import './sass/main.scss';

if (typeof window.accessToken !== 'undefined' && window.accessToken !== null) {
    store.dispatch('setTokens', window.accessToken);
    store.commit('isAuthenticated', {state: true});
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */


/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */
let commonHeaders = {
    "Accept": "application/json",
    'X-Requested-With': 'XMLHttpRequest',
    //'Access-Control-Allow-Credentials' : true,
};
axios.defaults.baseURL = APP_CONFIG.URL;
Object.keys(commonHeaders).forEach((header) => {
    axios.defaults.headers.common[header] = commonHeaders[header];
});

/**
 * Here we will fecth the token from local storage and
 * attach it (if exists) to the Authorization header on EVERY request.
 */

axios.interceptors.request.use((config) => {

    // request header
    if (store.getters.isAuthenticated) {
        config.headers.Authorization = "Bearer " + store.getters.getAccessToken;
    }
    return config;
});
/**
 * Here is where we can refresh the token.
 */
axios.interceptors.response.use((response) => {
    /**
     * If we get a 401 response from the API means that we are Unauthorized to
     * access the requested end point.
     * This means that probably our token has expired and we need to get a new one.
     */

    return response;
}, error => {
    if (error.response !== 'undefined' && error.response.status === 401) {
        Utils.notify({
            message: 'Your are not authenticated to this services',
            title: 'Authentication Failed',
            type: 'error'
        });
        router.replace('/login');
    }
    if (error.response !== 'undefined' && error.response.status === 403) {
        Utils.notify({
            message: error.response.data.message,
            title: 'Operation not permitted',
            type: 'error'
        });
    }
    throw error;
});

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import LaravelEcho from 'laravel-echo'
import AuthService from './services/vueAuth';
//
const io = require('socket.io-client');
//
const Echo = new LaravelEcho({
    client: io,
    broadcaster: 'socket.io',
    host: process.env.VUE_APP_API_URL,
    auth: {
        headers: {
            'Authorization': "Bearer " + AuthService.getToken().accessToken,
        }
    },
});

window.Utils = Utils;
window.axios = axios;
window.Echo = Echo;
window._ = _;

export {axios, Echo, Utils, _}
